import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Preferences.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /preferences': 200,
    // 'get /user/preferences': 200,
    // 'post /user/preferences': 200,
  })
}

export const getSelectedPreferences = accessToken =>
  client({
    url: '/user/preferences',
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export function getPreferences() {
  return client({
    url: '/preferences',
    method: 'get',
    headers: {
      'X-Device-Id': generateDeviceId(),
    },
  })
}

export const postPreferences = (data, header) => {
  const { ids } = data
  const { accessToken } = header

  return client({
    url: 'user/preferences',
    method: 'post',
    data: {
      ids,
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
}
